<template>
    <div>
        <el-dialog :visible.sync="showModal" width="35%" @close="$emit('close-modal')">
            <h2 class="text-2xl font-semibold mb-3">Dispatch</h2>
            <div class="flex items-start justify-between mb-1">
                <div>
                    <div>Dispatch ID: <b>{{ consolidation.consolidationReference &&
                        consolidation.consolidationReference }}</b></div>
                </div>
                <div>
                    <div>
                        <p>Item Count: <b>{{ totalItems }} ({{
                            totalShippmentWeight }}KG)</b>
                        </p>
                    </div>
                </div>
            </div>
            <div class="flex items-start justify-between mb-4">
                <div>
                    <div>Consolidation Count: <b>1</b></div>
                </div>
                <div>
                    <div>
                        <p>Shipments/Receiver Count : <b>{{ selectedShipments && selectedShipments.length }}</b>
                        </p>
                    </div>
                </div>
            </div>

            <div>
                <div class="flex justify-between">
                    <p>{{ selectedShipments && selectedShipments.length }} Customers, {{ totalPackage }} Packages(s)</p>
                    <div @click="showItemsDiv = !showItemsDiv">
                        <ArrowDownIcon class="cursor-pointer " />
                        <!-- <ArrowUpIcon /> -->
                    </div>

                </div>
                <div v-if="showItemsDiv">
                    <div class="w-full flex flex-wrap items-center mt-2 mb-2">
                        <span class="block w-1/3"><b>{{ route }}</b></span>
                        <span class="block w-1/3 text-center">{{ selectedShipments && selectedShipments.length }}
                            shipment(s)</span>
                        <span class="block w-1/3 text-right">{{ totalItems }} Items</span>
                    </div>
                </div>

                <div class="mt-3">
                    <div>
                        <label class="mb-1">Route</label>
                        <input v-model="route" :disabled="true"
                            class="w-full py-2 px-2 bg-primary-lightblue cursor-not-allowed" />
                    </div>
                </div>

                <div class="mt-3">
                    <div>
                        <label class="mb-1">Vehicle/ Carrying Capacity</label>
                        <input v-model="vehicleCapacity" :disabled="true"
                            class="w-full py-2 px-2 bg-primary-lightblue cursor-not-allowed" />
                    </div>
                </div>

                <div class="mt-3">
                    <div>
                        <label class="mb-1">Destination</label>
                         <input v-model="dispatchDestination" :disabled="true"
                            class="w-full py-2 px-2 bg-primary-lightblue cursor-not-allowed" />
                    </div>
                </div>



                <div class="mt-3">
                    <div>
                        <label class="mb-1">Driver/Dispatcher</label>

                        <el-select v-model="driver" placeholder="Select Driver">
                            <el-option v-for="driver in drivers" :key="driver.id" :label="driverLabel(driver)"
                                :value="driver.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>

            <div class="flex justify-end mt-5" style="height: 80px">

                <div class="h-full">
                    <button class="h-full font-semibold" style="width: 120px" @click="closeModal">
                        Cancel
                    </button>

                    <primary-button :loading="dispatchLoading" :disabled="disableSaveDispatch" @click="dispatch"
                        class="h-full bg-primary-yellow rounded font-semibold !text-black"
                        style="width: 120px;height: 40px" buttonText="Save">

                    </primary-button>
                </div>
            </div>


        </el-dialog>
    </div>
</template>

<script>
import ArrowDownIcon from "@/components/UI/svgs/ArrowDownIcon.vue";
import { userId } from "@/services/apiConfig.js"

export default {
    components: {
        ArrowDownIcon,
    },
    props: {
        consolidation: {},
        showModal: {
            type: Boolean,
            required: true,
        }
    },
    data() {
        return {
            drivers: [],
            driver: null,
            dispatchLoading: false,
            destination: "",
            showItemsDiv: true,
            selectedShipments: [],
            vehicleCapacity: "",
            route: "",
        }
    },
    computed: {
        dispatchDestination() {
            return `${this.consolidation?.destinationTerminal?.name} (${this.consolidation?.destinationTerminal?.address}, ${this.consolidation?.destinationTerminal?.state})`
        },
        locationId() {
            return this.$store.getters.currentLocationId;
        },
        totalPackage() {
            return (this.selectedShipments || []).reduce((sum, shipment) => {
                const details = this.shipmentDetails(shipment)
                return sum + ((details && details.packages) ? details.packages.length : 0)
            }, 0)
        },
        totalItems() {
            return (this.selectedShipments || []).reduce((sum, shipment) => {
                const details = shipment
                const packages = details && details.packagees ? details.packagees : []
                return sum + packages.reduce((pkgSum, pkg) => {
                    return pkgSum + (Number(pkg.quantity) || 0)
                }, 0)
            }, 0)
        },
        totalShippmentWeight() {
            const totalWeight = (this.selectedShipments || []).reduce((shipmentSum, shipment) => {
                const packageWeight = (shipment?.packagees || []).reduce((pkgSum, pkg) => {
                    return pkgSum + (Number(pkg?.estimatedWeight) * Number(pkg?.quantity || 1))
                }, 0)

                return shipmentSum + packageWeight
            }, 0)
            return totalWeight;
        },
        disableSaveDispatch() {
            return this.driver == null || this.driver == undefined || this.driver == "" || this.dispatchLoading == true
        },
    },
    watch: {
        showModal(val) {
            if (!val) return;
            this.vehicleCapacity = this.consolidation?.fleet?.currentLoadCapacity;
            this.route = this.consolidation?.fleet?.route?.routeName;
            this.selectedShipments = this.consolidation?.shippings || []
            this.getDriver();
        }
    },
    methods: {
        shipmentDetails() {
            return {}

        },
        driverLabel(driver) {
            return driver?.driver?.firstname + ' ' + driver?.driver?.lastname + ' (' + driver?.driver?.mobile_no + ')'
        },
        async dispatch() {
            this.dispatchLoading = true
            const payload = {
                consolidationIds: [this.consolidation?.id],
                fleetId: this.driver,
                userId: userId(),
                terminalId: this.locationId
            }
            try {
                await this.$_updateConsolidationDispatch(payload);
                this.closeModal();
                this.$emit('refetch-consolidation')
            } catch (error) {
                this.handleError(error)
            } finally {
               this.dispatchLoading = false;
            }
        },
        async getDriver() {
            try {
                const { data: response } = await this.$_getOutboundDispatcher();
                this.drivers = response.data
            } catch (error) {
                this.handleError(error);
            }
        },
        closeModal() {
            this.$emit("close-modal");
        }
    },
}
</script>

<style lang="scss" scoped></style>